import React, { Component } from 'react';

class About extends Component {

  componentDidMount() {

    document.getElementsByClassName('nav-item')[0].classList.remove('active');
    document.getElementsByClassName('nav-item')[2].classList.remove('active');
    document.getElementsByClassName('nav-item')[1].classList.add('active');

    setTimeout(() => {

      let about = document.getElementsByClassName('aboutBio');


      for(let i=0; i < about.length; i++) {
        about[i].style.transition = "all 1s ease";
        about[i].style.width = "80%";
        about[i].style.fontSize = "1em";
        about[i].style.padding = "15px";
      }
    }, 100);

  }

  render() {

    return (
      <div className="content">
          <h2>About Puppedia</h2>
          
          <p className="aboutBio">
            Hello, my name is Candace, and I created Puppedia. 
          </p>
          <p className="aboutBio">
            Puppedia is an online encyclopedia of dog breeds, and through browsing you can learn all about your favorite breeds. 
            All images on the Puppedia application are sourced from either the Dog CEO API or the Wikipedia API, 
            and any information related to the specific breeds listed on Puppedia is retrieved from Wikipedia itself.  
          </p>
          
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/About.js